// Divider component
import { cn } from '@utils/classNames';

interface DividerProps {
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-2 px-4',
        className
      )}
    >
      <div className="bg-[#c0c0c0cc] w-full h-px" />
    </div>
  );
};




